import apiShippingGroups from '../../api/apiShippingGroups'

const state = {
    groups: [],
    modalStatus: false,
    userName: null,
    groupId: null,
    data: {
        user_id: null,
        type: 1,
        name: null,
        carsIds: [],
        cars: []
    }
}
const getters = {
    getShippingGroups: (state) => {
        return state.groups
    },
    getShippingGroupId: (state) => {
        return state.groupId
    },
    getShippingGroupUserName: (state) => {
        return state.userName
    },
    getShippingGroupModalStatus: (state) => {
        return state.modalStatus
    },
    getShippingGroupData: (state) => {
        return state.data
    },
    getShippingGroupUserId: (state) => {
        return state.data.user_id
    },
    getShippingGroupType: (state) => {
        return state.data.type
    },
    getShippingGroupName: (state) => {
        return state.data.name
    },
    getShippingGroupCars: (state) => {
        return state.data.carsIds
    },
    getShippingGroupFullCars:(state) => {
        return state.data.cars
    },
    getShippingGroupCarsById: state => carId => {
        return state.data['carsIds'].filter(a => a === carId)
    },
}

const mutations = {
    setShippingGroups: (state, newValue) => {
        state.groups = newValue
    },
    setShippingGroupId: (state, newValue) => {
        state.groupId = newValue
    },
    setShippingGroupUserName: (state, newValue) => {
        state.userName = newValue
    },
    setShippingGroupModalStatus: (state, newValue) => {
        state.modalStatus = newValue
    },
    addShippingGroupCars: (state, newValue) => {
        state.data.carsIds.push(newValue)
    },
    addShippingGroupFullCars: (state, newValue) => {
        state.data.cars.push(newValue)
    },
    setShippingGroupType: (state, newValue) => {
        state.data.type = newValue
    },
    setShippingGroupName: (state, newValue) => {
        state.data.name = newValue
    },
    setShippingGroupUserId: (state, newValue) => {
       state.data.user_id = newValue
    },
    removeCarFromShippingGroup: (state, carId) => {
        state.data['carsIds'] = state.data['carsIds'].filter(m => m !== carId)
    },
    removeFullCarFromShippingGroup: (state, car) => {
        state.data['cars'] = state.data['cars'].filter(m => m !== car)
    },
    setShippingGroupDataToDefault: (state) => {
        state.data = {
            user_id: null,
            type: 1,
            name: null,
            carsIds: [],
            cars: []
        }
    }
}

const actions = {
    updateShippingGroups: ({ commit }, newData) => {
        commit('setShippingGroups', newData)
    },
    updateShippingGroupId: ({ commit }, newData) => {
        commit('setShippingGroupId', newData)
    },
    updateShippingGroupUserName: ({ commit }, newData) => {
        commit('setShippingGroupUserName', newData)
    },
    updateShippingGroupCars: ({ commit }, newData) => {
        commit('addShippingGroupCars', newData)
    },
    updateShippingGroupFullCars: ({ commit }, newData) => {
        commit('addShippingGroupFullCars', newData)
    },
    changeShippingGroupType: ({ commit }, newData) => {
        commit('setShippingGroupType', newData)
    },
    changeShippingGroupName: ({ commit }, newData) => {
        commit('setShippingGroupName', newData)
    },
    changeShippingGroupUserId: ({ commit }, newData) => {
        commit('setShippingGroupUserId', newData)
    },
    removeCarFromShippingGroup: ({ commit }, carId) => {
        commit('removeCarFromShippingGroup', carId)
    },
    changeShippingGroupModalStatus: ({ commit }, newValue) => {
        commit('setShippingGroupModalStatus', newValue)
    },
    changeShippingGroupDataToDefault: ({ commit }) => {
        commit('setShippingGroupDataToDefault')
    },
    removeFullCarFromShippingGroup: ({ commit }, car) => {
        commit('removeFullCarFromShippingGroup', car)
    },
    fetchShippingGroups: (context, userId) => {
        apiShippingGroups
            .shippingGroupsListRequest(userId)
            .then((response) => {
                context.commit('setShippingGroups', response.data)

            })
            .catch((err) => {
                console.log(err)
            })
    },
    updateShippingGroupById: (context, data) => {
        let groupId = data.id
        let newData = { locked: data.locked }
        apiShippingGroups
            .updateShippingGroupRequest(groupId, newData)
            .then((response) => {
                context.dispatch('fetchCarsWithSearchQuery')
            })
            .catch((err) => {
                console.log(err)
            })
    }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/shippingGroup.js